var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95437 8.95438 0 20 0C31.0456 0 40 8.95437 40 20C39.1305 20 20 22.6087 20 22.6087L0 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20.0001C40 31.0457 31.0456 40.0001 20 40.0001C8.95437 40.0001 0 31.0457 0 20.0001",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2576 15.9072L18.953 17.1377L18.3069 19.1305L20.0012 17.898L21.6968 19.1285L21.0482 17.1363L22.7423 15.9039L20.6473 15.9052L19.9987 13.9131L19.3525 15.9059L17.2576 15.9072Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 11.3398C23.4239 10.4299 21.7007 10.0005 19.9999 10.0034V12.6116C21.257 12.6093 22.5306 12.9265 23.6955 13.5991C27.225 15.6369 28.4387 20.1663 26.4008 23.6959C24.3631 27.2254 19.8338 28.4391 16.3042 26.4012C15.2759 25.8076 14.4458 25.0015 13.8339 24.0712L11.6561 25.5091C12.484 26.7676 13.6087 27.8572 14.9999 28.6603C19.7752 31.4173 25.9031 29.7754 28.66 25.0001C31.4171 20.2248 29.7752 14.0969 24.9999 11.3398V11.3398Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2335 18.2609C13.5421 19.5249 14.0063 21.1101 15.2702 21.8015L23.7428 26.4312C23.1666 27.4844 23.4726 28.7664 24.5258 29.3426L26.8145 30.5945C27.8677 31.1708 29.1889 30.7839 29.765 29.7306L31.017 27.442L14.2335 18.2609Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngola);
export default __webpack_public_path__ + "static/media/angola.d09fba491be7a4a3a90b663796e2a369.svg";
export { ForwardRef as ReactComponent };